import axios from 'axios';
import { User } from '../types';

// APIのベースURL
const API_BASE_URL = process.env.REACT_APP_API_URL;

// 共通のAxios設定（クッキー送信を有効化）
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// ===== 認証関連API =====

// セッション情報を取得する関数
export const getSession = async () => {
  try {
    const response = await apiClient.get('/auth/session');
    return response.data;
  } catch (error) {
    console.error('セッション取得エラー:', error);
    throw error;
  }
};

// ログイン関数
export const login = async (email: string, password: string) => {
  try {
    const response = await apiClient.post('/auth/login', {
      email,
      password,
    });
    return response.data;
  } catch (error) {
    console.error('ログインエラー:', error);
    throw error;
  }
};

// ログアウト関数
export const logout = async () => {
  try {
    await apiClient.post('/auth/logout');
  } catch (error) {
    console.error('ログアウトエラー:', error);
    throw error;
  }
};

// ===== 管理者用API =====

// 全ユーザー一覧の取得
export const getAllUsers = async (): Promise<User[]> => {
  try {
    const response = await apiClient.get('/admin/users');
    return response.data.users;
  } catch (error) {
    console.error('ユーザー一覧取得エラー:', error);
    throw error;
  }
};

// ユーザーの役割を更新
export const updateUserRole = async (
  userId: string,
  role: 'admin' | 'user'
): Promise<void> => {
  try {
    await apiClient.post('/admin/users/role', { userId, role });
  } catch (error) {
    console.error('ユーザー役割更新エラー:', error);
    throw error;
  }
};
